import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private apiKey = environment.googleMapsApiKey;
  private scriptLoaded = false;

  private readonly httpClient = inject(HttpClient);

  loadGoogleMaps(): Observable<boolean> {
    if (this.scriptLoaded) {
      return of(true);
    }

    const url = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=initMap`;
    return this.httpClient.jsonp(url, 'callback').pipe(
      map(() => {
        this.scriptLoaded = true;
        return true;
      }),
      catchError((res) => {
        console.log(res);

        return of(false);
      })
    );
  }
}
